  
<div class="content-wrapper">
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> New Exit Clearance</h4>
         
            <form class="forms-sample" #ngNewExitForm="ngForm" name="form"
           
               (ngSubmit)="ngNewExitForm.form.valid && onSubmit()">
           
              
              
               <br>
               <div style="background: #ECECEC;padding:30px;">
                <div class="row">
               
                  <!-- Employee Name -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedUserId">Employee Name<span> *</span></label>
                      
                      <ng-select required [(ngModel)]="selectedUser" name="selectedUser"
                       (change)="onUserChange(selectedUser)" aria-placeholder="Select Employee">
                      <!-- <ng-option value="">-- Select Employee --</ng-option> -->
                      <ng-option [value]="user" *ngFor="let user of Allusers" >{{user.firstName}} {{user.lastName}}
                      </ng-option>
                    </ng-select>
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewExitForm.submitted && !selectedUser">
                      Employee Name is required!
                    </div>
                    </div>
                  </div>

                  <!-- <div class="col">
                    <div class="form-group">
                      <label for="selectedUserId">Employee Name<span> *</span></label>
                      <ng-select [items]="Allusers"
                                 bindLabel="firstName"
                                 bindValue="user"
                                 placeholder="-- Select Employee --"
                                 [(ngModel)]="selectedUser"
                                 (change)="onUserChange(selectedUser)"
                                 [searchable]="true">
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.firstName }} {{ item.lastName }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          {{ item.firstName }} {{ item.lastName }}
                        </ng-template>
                      </ng-select>
                      
                      <div class="alert alert-danger" role="alert"
                           *ngIf="ngNewExitForm.submitted && !selectedUser">
                        Employee Name is required!
                      </div>
                    </div>
                  </div> -->
                  

                    <!-- SAP Number  -->
              <div class="col">
                <div class="form-group">
                  <label for="description">SAP Number<span> *</span></label>
                  <input type="text" readonly  class="form-control" id="sapNumber" [(ngModel)]="sapNumber"
                    placeholder="SAP Number " name="sapNumber"
                      #Sapnumber="ngModel" required>
                    <div class="alert alert-danger" role="alert"
                    *ngIf="ngNewExitForm.submitted && Sapnumber.errors">
                    SAP Number is required!
                  </div>
                </div>
              </div>


               <!-- LAP EMAIL  -->
              <div class="col">
                <div class="form-group">
                    <label for="description">LAP Email<span> *</span></label>
                    <input type="text" readonly  class="form-control" id="lapEmail" [(ngModel)]="lapEmail"
                      placeholder="Lap Email " name="lapEmail"
                        #LapEmail="ngModel" required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$">
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewExitForm.submitted && LapEmail.errors">
                      LAP Email is required!
                    </div>
                    <div class="alert alert-danger" role="alert" *ngIf="LapEmail.errors?.pattern">Please enter a valid email address!</div>
                </div>
              </div>
                  
              </div>
                  <div class="row">
                 
                 <div class="col">
                  <div class="form-group">
                    <label for="exampleInputCity1">Designation<span> *</span></label>
                    <input type="text" class="form-control" id="designation" placeholder="ex: Designation" [(ngModel)]="designation"
                    #Designation="ngModel" name="designation" required>
                    <div class="alert alert-danger" role="alert"
                    *ngIf="ngNewExitForm.submitted && Designation.errors">
                    Designation is required!
                  </div>
                  </div>
                </div>

                   <!-- Function  -->
                    <div class="col">
                      <div class="form-group">
                        <label for="selectedfunction">Function<span> *</span></label>
                        <!-- <select class="form-control" required [(ngModel)]="SelectedDepartmentName" name="SelectedDepartmentName"
                          id="SelectedDepartmentName" #function="ngModel"  (change)="onDeptChange(SelectedDepartment)">
                          <option value="">-- Select Function --</option>
                          <option [value]="department" *ngFor="let department of Departments" [ngValue]="department">{{department.name}}
                          </option>
                        </select> -->
                        <input type="text" readonly class="form-control" id="SelectedDepartmentName" [(ngModel)]="SelectedDepartmentName"
                        placeholder="Function " name="SelectedDepartmentName"
                          #LapEmail="ngModel" >
                        <!-- <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewExitForm.submitted && function.errors">
                        Function is required!
                      </div> -->
                      </div>
                    </div> 
                  <!-- Unit  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Department<span> *</span></label>
                   
                      <!-- <ng-select  required [(ngModel)]="SelectedUnit"  id="selectedFunctionId" #unit="ngModel" name="selectedFunctionId"    (change)="onUnitChange(SelectedUnit)">
                        <ng-option *ngFor="let function of Functions" [value]="function" >
                          {{function.name}}</ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewExitForm.submitted && unit.errors">
                      Unit is required!
                    </div> -->
                    <input type="text" readonly  class="form-control" id="employeeUnitName" [(ngModel)]="employeeUnitName"
                    placeholder="Department " name="employeeUnitName"
                      #LapEmail="ngModel" >
                    </div>
                  </div>
                  <!-- Location  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedLocation">Location<span> *</span></label>
                   
                      <!-- <ng-select  required [(ngModel)]="SelectedUnit"  id="selectedFunctionId" #unit="ngModel" name="selectedFunctionId"    (change)="onUnitChange(SelectedUnit)">
                        <ng-option *ngFor="let function of Functions" [value]="function" >
                          {{function.name}}</ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewExitForm.submitted && unit.errors">
                      Unit is required!
                    </div> -->
                    <input type="text" readonly  class="form-control" id="SelectedLocationName" [(ngModel)]="SelectedLocationName"
                    placeholder="Location " name="SelectedLocationName"
                      #LapEmail="ngModel" >
                    </div>
                  </div>
                </div>

         <div class="row">
          <!--  personalPhoneNumbe  -->
            <div class="col">
                <div class="form-group">
                  <label for="description">Personal Phone Number<span> *</span></label>
                  <input type="text" class="form-control" id="personalPhoneNumber"  [(ngModel)]="personalPhoneNumber" required
                    placeholder=" Personal Phone Number" name="personalPhoneNumber" #PersonalPhoneNumber="ngModel" 
                    pattern="^\d+$">
                    <div class="alert alert-danger" role="alert"
                    *ngIf="ngNewExitForm.submitted && PersonalPhoneNumber.errors">

                    Personal Phone Number is required!
                  </div>
                  <div class="alert alert-danger" role="alert" *ngIf="PersonalPhoneNumber.errors?.pattern">Phone Number must be digits!</div>
                </div>
              </div>

      <!-- Personal Email  -->
      <div class="col">
        <div class="form-group">
            <label for="description">Personal Email<span> *</span></label>
            <input type="text" class="form-control" id="personalEmail"  [(ngModel)]="personalEmail" required
              placeholder=" Personal Email" name="personalEmail" #PersonalEmail="ngModel" 
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$">
              <div class="alert alert-danger" role="alert"
              *ngIf="ngNewExitForm.submitted && PersonalEmail.errors">
              Personal Employee Personal Email is required!
            </div>
            <!-- <div class="alert alert-danger" role="alert" *ngIf="personalEmail.errors?.pattern">Please enter a valid email address!</div> -->
        </div>
      </div>
        <!-- Last Working  Date  -->
        <div class="col">
            <div class="form-group">
              <label for="exampleInputCity1">Last Working Date<span> *</span></label>
              <input type="date" class="form-control" id="lastWorkingDate" placeholder="" name="lastWorkingDate"
               [(ngModel)]="lastWorkingDate" required
                #LastWorkingDate="ngModel">
                <div class="alert alert-danger" role="alert"
                *ngIf="ngNewExitForm.submitted && LastWorkingDate.errors">
                Last Working Date is required!
              </div>
            </div>
          </div>
        </div>

        <div class="row">

          <!-- Reason For Exit -->
          <div class="col">
            <div class="form-group">
              <label for="selectedUserId">Reason For Exit<span> *</span></label>
              
              <ng-select required [(ngModel)]="selectedReason" name="selectedReason"
              aria-placeholder="Select Reason For Exit">
              <!-- <ng-option value="">-- Select Employee --</ng-option> -->
              <ng-option [value]="reason.value" *ngFor="let reason of dropdownData" >{{reason.options}} 
              </ng-option>
            </ng-select>
              <div class="alert alert-danger" role="alert"
              *ngIf="ngNewExitForm.submitted && !selectedReason">
              Reason for exit is required!
            </div>
            </div>
          </div>


  <!-- Permanent Address  -->
  <div class="col">
    <div class="form-group">
      <label for="exampleInputCity1">Permanent Address<span> *</span></label>
      <input type="text" class="form-control" id="permanentAddress" placeholder="" name="permanentAddress"
       [(ngModel)]="permanentAddress"  required
        #PermanentAddress="ngModel">
        <div class="alert alert-danger" role="alert"
        *ngIf="ngNewExitForm.submitted && PermanentAddress.errors">
        Employee Permanenet Address is required!
      </div>
    </div>
  </div>



  </div>

  <div class="row">
    <!-- Line Manager  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Line Manager<span> *</span></label>
                                 <ng-select  required [(ngModel)]="SelectedLM"  id="selectedManagerId"  name="selectedManagerId" (change)="onLMChange(SelectedLM)">
                            <ng-option *ngFor="let manager of Managers" [value]="manager"  >
                              {{manager.firstName}} -   {{manager.email}}</ng-option>
                          </ng-select>
                    
                             <!-- error block -->
                    <div class="alert alert-danger" *ngIf="ngNewExitForm.submitted && !SelectedLM">
                      <sup>*</sup>Please provide Unit Head to approve
                    </div>
                    </div>
                  </div> 
                <!-- HRBP  -->
                <div class="col">
                  <div class="form-group">
                    <label for="selectedfunction">HRBP<span> *</span></label>
                 
                   <ng-select  required [(ngModel)]="selectedHRBP"  id="selectedhrbpId" name="selectedHRBP"   (change)="onHRBPChange(selectedHRBP)"    >
                            <ng-option *ngFor="let hrbp of HRBPS" [value]="hrbp">
                              {{hrbp.firstName}} -   {{hrbp.email}}</ng-option>
                          </ng-select>
  
                    <!-- error block -->
                    <div class="alert alert-danger" *ngIf="ngNewExitForm.submitted && !selectedHRBP">
                      <sup>*</sup>Please provide HRBP to approve
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
    NeedMedicalWaiver 
                  <div class="col">
                    <div class="form-check">
                      <label for="NeedMedicalWaiver" class="form-check-inline">Need Medical Waiver</label>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="needMedicalWaiver" [(ngModel)]="NeedMedicalWaiver" name="needMedicalWaiver">
                        <label class="form-check-label" for="needMedicalWaiver">
                          Yes
                        </label>
                      </div>
                    </div>
                  </div>
                </div> -->
        </div>
       
             
              <br>
  
         
           
         
         <br>

           <br>
            <hr>
                  <div class="text-left">
                    <button type="submit" [disabled]="clicked && ngNewExitForm.valid"   class="btn btn-primary mr-2 ">Submit</button>

                    <button onclick="location.reload()" class="btn btn-light">Cancel</button>
                  </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>